import type { IconNode } from '../types';

/**
 * @name barber-pole
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNyA2aDEwIiAvPgogIDxwYXRoIGQ9Ik03IDIyaDEwIiAvPgogIDxwYXRoIGQ9Ik04IDIyVjZhNCA0IDAgMCAxIDggMHYxNiIgLz4KICA8cGF0aCBkPSJtOCAxMS41IDgtNCIgLz4KICA8cGF0aCBkPSJtOCAxNiA4LTQiIC8+CiAgPHBhdGggZD0ibTggMjAuNSA4LTQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/barber-pole
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const barberPole: IconNode = [
  ['path', { d: 'M7 6h10', key: '1bwv94' }],
  ['path', { d: 'M7 22h10', key: '10w4w3' }],
  ['path', { d: 'M8 22V6a4 4 0 0 1 8 0v16', key: '1y53bs' }],
  ['path', { d: 'm8 11.5 8-4', key: '1stw00' }],
  ['path', { d: 'm8 16 8-4', key: 'zltscp' }],
  ['path', { d: 'm8 20.5 8-4', key: '1uw1dx' }],
];

export default barberPole;
